import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api, apiFetchRaw } from '@/lib/api';

/**
 * Profil resmi (18 Ekim 2026; sahip: "sağ üstteki MS logosuna resim koyabilelim, daha şık durur").
 *
 * Resim ortak klasörde ve e-postaya bağlı — dört panelde aynı. Erişim jetonu bellekte olduğu
 * için `<img src>` doğrudan sunucuya gidemiyor; resim yetkili istekle çekilip geçici bir
 * adrese (blob URL) konuyor.
 */
const ANAHTAR = ['profil-resmi'] as const;

export function useProfilResmi(email: string | undefined): string | null {
  const q = useQuery({
    queryKey: [...ANAHTAR, email ?? ''],
    enabled: email !== undefined,
    staleTime: Infinity,
    queryFn: async () => {
      const r = await apiFetchRaw('/auth/me/avatar', { method: 'GET' });
      if (!r.ok || r.status === 204) return null;
      return URL.createObjectURL(await r.blob());
    },
  });
  return q.data ?? null;
}

/** Seçilen resmi tam ortadan kare kırpıp 256×256 JPEG'e çevirir (≈20-40 KB). */
async function kucult(dosya: File): Promise<string> {
  const resim = await createImageBitmap(dosya);
  const kenar = Math.min(resim.width, resim.height);
  const tuval = document.createElement('canvas');
  tuval.width = 256;
  tuval.height = 256;
  const c = tuval.getContext('2d');
  if (!c) throw new Error('Tarayıcı resmi işleyemedi.');
  c.drawImage(
    resim,
    (resim.width - kenar) / 2,
    (resim.height - kenar) / 2,
    kenar,
    kenar,
    0,
    0,
    256,
    256,
  );
  resim.close();
  return tuval.toDataURL('image/jpeg', 0.88);
}

export function useProfilResmiIslemleri() {
  const qc = useQueryClient();
  const yenile = () => qc.invalidateQueries({ queryKey: ANAHTAR });
  return {
    async yukle(dosya: File): Promise<void> {
      if (!dosya.type.startsWith('image/')) throw new Error('Lütfen bir resim dosyası seçin.');
      await api.put('/auth/me/avatar', { veri: await kucult(dosya) });
      await yenile();
    },
    async kaldir(): Promise<void> {
      await api.delete('/auth/me/avatar');
      await yenile();
    },
  };
}
